import React from "react";
import { Button, dialog } from "../../nq-component";
import { getObjectUseCase, upsertUseCase } from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseFormPage from "../../base/BaseFormPage";
import FormFactory from "../../components/FormFactory";
import ApplicationFormPresenter from "./ApplicationFormPresenter";
import { Link } from "react-router-dom";
import schemaPersonalForm1 from "./schemas/schemaPersonalForm1.json";
import schemaIdForm from "./schemas/schemaIdForm.json";
import schemaEmployment from "./schemas/schemaEmployment.json";
import schemaCharacterRef from "./schemas/schemaCharacterRef.json";
import schemaElementaryForm from "./schemas/schemaElementaryForm.json";
import schemaHSForm from "./schemas/schemaHSForm.json";
import schemaColForm from "./schemas/schemaColForm.json";
import schemaDocForm from "./schemas/schemaDocForm.json";
import schemaPresentAddress from "./schemas/schemaPresentAddress.json";
import schemaPermanentAddress from "./schemas/schemaPermanentAddress.json";
import InputFactory from "../../components/InputFactory";
import NavBar from "../../components/navbar";

class ApplicationFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      isAddressSame: false,
      employmentForm: [],
      object: {},
      selectedjob: "",
      whereLGSSee: "select",
      employers: [{ id: crypto.randomUUID() }],
      characterref: [{ id: crypto.randomUUID() }],
      selectedOptions: {
        coe: false,
        reportCard: false,
        diploma: false,
      },
      uploadedFiles: {
        coe: null,
        reportCard: null,
        diploma: null,
      },
      selectedNames: [],
      isschoolRecord: false,
    };
    this.presenter = new ApplicationFormPresenter(
      this,
      upsertUseCase(),
      getObjectUseCase()
    );
  }

  getCollectionName() {
    return "online_applicants";
  }

  assignSubmit() {
    dialog.fire({
      html: (
        <>
          <div className="d-flex">
            <div className="m-4">
              <i
                class="bi bi-person-check fs-2 p-2"
                style={{ backgroundColor: "#e8ecf3", color: "#D18237" }}
              ></i>
            </div>
            <div className="ms-3" style={{ marginTop: "35px" }}>
              <h5 className="" style={{ color: "#D18237" }}>
                Assign Applicant
              </h5>
              <p>Are you sure you want this applicant to be assign to you?</p>
            </div>
          </div>
          <div className="text-center mb-3">
            <button
              className="btn"
              style={{ backgroundColor: "#e8ecf3" }}
              onClick={() => dialog.close()}
            >
              Cancel
            </button>
            <button
              className="btn text-white ms-2"
              style={{ backgroundColor: "#D18237" }}
            >
              Confirm
            </button>
          </div>
        </>
      ),
      footer: false,
    });
    this.presenter.assignSubmit();
  }

  render() {
    const { object, whereLGSSee } = this.state;
    const user = this.getCurrentUser();
    console.log("objct", object);

    return (
      <>
        <NavBar user={user} />
        <div>
          <div className="p-5 overflow-auto">
            <div className="ms-4  d-flex gap-4 justify-content-between">
              <div className="d-flex">
                <Link to="/recruiter/online-applicants">
                  <i
                    class="bi bi-arrow-left fs-4"
                    style={{ color: `#303030CC` }}
                  ></i>
                </Link>
                <h1 className="fs-2 fw-bold ms-3" style={{ color: `#D18237` }}>
                  Application Form
                </h1>
              </div>

              <div>
                <button
                  className="btn text-white"
                  style={{ backgroundColor: "#D18237" }}
                  onClick={this.assignSubmit.bind(this)}
                >
                  <i class="bi bi-person-check me-2"></i>
                  Assign to me
                </button>
              </div>
            </div>
            <div className="d-flex flex-column">
              <div className="bg-white mt-4 p-4 rounded-3 d-flex flex-column gap-0">
                <form>
                  <p className="fs-5 fw-bold p-0 m-0">Instructions:</p>
                  <p className="p-0 m-0">
                    1. Answer ALL questions completely and accurately.
                  </p>
                  <p className="p-0 m-0">
                    2. This must be filled-out in your OWN handwriting.
                  </p>
                  <div className="d-flex flex-column justify-content-md-start mt-3 gap-2">
                    <div className="col-md-3 d-flex flex-column gap-2">
                      <b>Where did you see LGS?</b>
                      <InputFactory
                        type="Enum"
                        required
                        className="form-control bg-light-subtle p-2"
                        placeholder="Select"
                        field="seeLGS"
                        defaultValue={object.seeLGS}
                        disabled
                      />
                      {whereLGSSee === "Recruiter" ? (
                        <div>
                          <select className="form-control bg-light-subtle p-2">
                            <option selected disabled>
                              Select Recruiter
                            </option>
                          </select>
                        </div>
                      ) : (
                        <div className="d-flex flex-column">
                          <p className="text-muted m-0 p-0">
                            Position/s Applied for:
                          </p>
                          {/* <p className="m-0 p-0">
                            {selectJobs.map((job) => {
                              return job + ", ";
                            })}
                          </p> */}
                          <InputFactory
                            type="Enum"
                            required
                            className="form-control bg-light-subtle p-2"
                            placeholder="Select"
                            field="positionApplied"
                            defaultValue={object.positionApplied}
                            disabled
                          />
                        </div>
                      )}
                    </div>
                    <div className="col-md-3 mt-2">
                      <b>Do you have any relative in:</b>
                      <div className="mt-2">
                        <label className="form-label fs-sm">LGS</label>
                        <InputFactory
                          type="Enum"
                          options={["Yes", "No"]}
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="relativeLGS"
                          defaultValue={object.relativeLGS}
                          disabled
                        />
                      </div>
                      <div>
                        <label className="form-label fs-sm">Client</label>
                        <InputFactory
                          type="Enum"
                          options={["Yes", "No"]}
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Select"
                          field="relativeClient"
                          defaultValue={object.relativeClient}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    <b>Personal Information</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaPersonalForm1}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="mt-4">
                      <b>Permanent Address</b>
                    </div>
                    <FormFactory
                      schema={schemaPermanentAddress}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex gap-2">
                      <input type="checkbox" className="cursor-pointer" />
                      <p className="m-0 p-0">
                        Permanent Address same as a Present Address
                      </p>
                    </div>
                  </div>

                  {
                    <div className="row justify-content-md-start mt-3">
                      <div className="mt-4">
                        <b>Present Address</b>
                      </div>
                      <FormFactory
                        schema={schemaPresentAddress}
                        object={object}
                        disabled
                      />
                    </div>
                  }

                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaIdForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>Educational Information</b>
                    <hr />
                  </div>
                  <div className="mt-4">
                    <b>Elementary</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaElementaryForm}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="mt-4">
                    <b>High School</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaHSForm}
                      object={object}
                      disabled
                    />
                  </div>
                  <div className="mt-4">
                    <b>College</b>
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaColForm}
                      object={object}
                      disabled
                    />
                  </div>

                  <div className="row justify-content-md-start mt-3">
                    <div className="col-md-5 d-flex">
                      <InputFactory
                        type="Boolean"
                        field="isFreshGrad"
                        label="Fresh Graduate"
                        object={object}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="mt-4">
                    <b>Employment Background</b>
                    <hr />
                  </div>
                  <div>
                    <div className="row justify-content-md-start mt-3">
                      {this.state.employers.map((employer, index) => (
                        <div
                          key={employer.id}
                          className="row justify-content-md-start mt-3"
                        >
                          {object.employmentBackground?.map(
                            (employment, index) => (
                              <FormFactory
                                schema={schemaEmployment}
                                object={employment}
                                disabled
                              />
                            )
                          )}
                          {this.state.employers.length > 1 && (
                            <u className="text-danger mt-2 cursor-pointer">
                              Delete Employer
                            </u>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>

                  <div>
                    <u
                      className="cursor-pointer mt-2"
                      style={{ color: `#D18237` }}
                    >
                      Add more employer
                    </u>
                  </div>
                  <div className="mt-4">
                    <b>Character References</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    {this.state.characterref.map((character, index) => (
                      <div
                        key={character.id}
                        className="row justify-content-md-start mt-3"
                      >
                        {object.characterReferences?.map((reference, index) => (
                          <FormFactory
                            schema={schemaCharacterRef}
                            disabled
                            object={reference}
                          />
                        ))}
                        {this.state.characterref.length > 1 && (
                          <u className="text-danger mt-2 cursor-pointer">
                            Delete Character Reference
                          </u>
                        )}
                      </div>
                    ))}
                  </div>
                  <div>
                    <u
                      className="cursor-pointer mt-2"
                      style={{ color: `#D18237` }}
                    >
                      Add more references
                    </u>
                  </div>
                  <div className="mt-4">
                    <b>School Record</b>
                    <hr />
                  </div>
                  <div className="mt-3">
                    <div className="bg-light-subtle p-2 position-relative col-lg-3 border border-1 rounded-1 z-3 cursor-pointer">
                      <div
                        className={`bg-white text-start shadow-sm border border-1 position-absolute 
                       `}
                        style={{ bottom: "-100", cursor: "pointer" }}
                      >
                        {/* <div className="d-flex flex-column z-3">
                          <div className="d-flex justify-content-between px-3">
                            <label className="p-2">
                              <input type="checkbox" name="diploma" disabled />
                              Diploma
                            </label>
                          </div>
                          <div className="d-flex justify-content-between px-3">
                            <label className="p-2">
                              <input type="checkbox" name="tor" disabled />
                              TOR
                            </label>
                          </div>
                          <div className="p-2">
                            <label>
                              <input
                                type="checkbox"
                                name="reportCard"
                                disabled
                              />
                              Report Card
                            </label>
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-row justify-content-md-start mt-3 gap-3">
                    {
                      <div className="col-lg-3">
                        <label>Diploma</label>
                        <InputFactory
                          type="String"
                          _type="Image"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Diploma"
                          field="diploma"
                          disabled
                          object={object}
                        />
                        {/* 
                        {uploadedFiles.diploma && (
                          <p>{uploadedFiles.diploma.name}</p>
                        )} */}
                      </div>
                    }
                    {
                      <div className="col-lg-3">
                        <label>TOR</label>
                        <InputFactory
                          type="String"
                          _type="Image"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="TOR"
                          field="tor"
                          disabled
                          object={object}
                        />
                        {/* {uploadedFiles.tor && <p>{uploadedFiles.tor.name}</p>} */}
                      </div>
                    }
                    {
                      <div className="col-lg-3">
                        <label>Report Card</label>
                        <InputFactory
                          type="String"
                          _type="Image"
                          required
                          className="form-control bg-light-subtle p-2"
                          placeholder="Report Card"
                          field="reportCard"
                          disabled
                          object={object}
                        />
                        {/* {uploadedFiles.reportCard && (
                          <p>{uploadedFiles.reportCard.name}</p>
                        )} */}
                      </div>
                    }
                  </div>
                  <div className="mt-4">
                    <b>Upload Documents</b>
                    <hr />
                  </div>
                  <div className="row justify-content-md-start mt-3">
                    <FormFactory
                      schema={schemaDocForm}
                      disabled
                      object={object}
                    />
                  </div>

                  <div className="d-flex gap-2 mt-4">
                    <Button
                      type="submit"
                      className="p-2 text-white rounded-1 border-0 fw-bold px-4"
                      style={{ backgroundColor: `#D18237` }}
                    >
                      Submit Application
                    </Button>
                    <Link to={`/jobportal`}>
                      <button className="p-2 fw-bold rounded-1 border-0 px-4">
                        Cancel
                      </button>
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(ApplicationFormPage);
